import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { AuthService } from '../../core/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-magic-link-page',
  templateUrl: './magic-link-page.component.html',
  styleUrls: ['./magic-link-page.component.scss']
})
export class MagicLinkPageComponent {

  public submitAttempted = false;
  public loading = true;
  public errorMsg: string;
  public successMsg: string;

  public resetToken: string;

  constructor(
    private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    @Inject(PLATFORM_ID) protected platformId) { }

  ngOnInit() {
    const resetData = this.activatedRoute.snapshot.queryParams;
    this.resetToken = resetData.token;
    if (isPlatformBrowser(this.platformId)) {
      this.magicLink();
    }
  }

  magicLink() {
    this.errorMsg = null;

    this.loading = true;

    this.authService.magicLink(this.resetToken).subscribe((res) => {
      this.authService.saveLoginInfo(res);
      this.router.navigateByUrl('/dashboard');
      this.loading = false;
    }, err => {
      this.errorMsg = err.errMsg;
      this.loading = false;
    });
  }

}
